import { Suspense } from "react";

const Wrapper = ({ children }) => {
    return (
        <Suspense
            fallback={
                <div className="h-screen grid place-content-center">
                    <img
                        src="/loader.png"
                        alt="loading..."
                        className="animate-bounce h-24 w-h-24 object-cover"
                    />
                </div>
            }
        >
            {children}
        </Suspense>
    );
};

export default Wrapper;
